import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Debug helper
const log = (msg: string, data?: unknown) => {
  console.log(`[CDRS] ${msg}`, data || '');
};

log('Main.tsx starting...');

// Global error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('[CDRS] Global error:', event.error);
  console.error('[CDRS] Error details:', {
    message: event.error?.message,
    stack: event.error?.stack,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[CDRS] Unhandled promise rejection:', event.reason);
});

try {
  log('Getting root element...');
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    throw new Error('Root element #root not found in DOM');
  }
  
  log('Creating React root...');
  const root = createRoot(rootElement);
  
  log('Rendering App...');
  root.render(<App />);
  
  log('App rendered successfully');
} catch (error) {
  console.error('[CDRS] Failed to render app:', error);
  
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack : 'No stack trace';
  
  document.body.innerHTML = `
    <div style="padding: 2rem; font-family: system-ui, sans-serif; max-width: 800px; margin: 0 auto;">
      <h1 style="color: #dc2626;">🚨 Failed to Load Application</h1>
      <div style="background: #fee2e2; border: 1px solid #ef4444; padding: 1rem; border-radius: 8px; margin: 1rem 0;">
        <strong>Error:</strong> ${errorMessage}
      </div>
      <pre style="background: #f3f4f6; padding: 1rem; overflow: auto; border-radius: 8px; font-size: 0.875rem;">
${errorStack}
      </pre>
      <button onclick="location.reload()" style="padding: 0.75rem 1.5rem; background: #3b82f6; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 1rem;">
        🔄 Reload Page
      </button>
    </div>
  `;
}
